import type { AxiosResponse } from 'axios';

import axiosInstance from '../../instance';
import ROUTES from '../../routes';
import type { IVideo } from './types';

export const create = (data: ArrayBuffer, type: 'oncar' | 'tablet')
  : Promise<void | AxiosResponse<IVideo>> => axiosInstance({
  url: `${ROUTES.VIDEOS}`,
  method: 'POST',
  headers: {
    authorization: true,
  },
  params: {
    type,
  },
  data,
});
